import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommandResult } from '../models/commandResult';
import { Security } from '../utils/security.util';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private http: HttpClient) { }

  mycod() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/referal/mycod', this.options());
  }

  getAllBalance() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/balance/all', this.options());
  }

  getBalanceReal() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/balance/real', this.options());
  }

  getBalanceBs() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/balance/bs', this.options());
  }

  getBalanceDolar() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/balance/dolar', this.options());
  }

  getBalanceYield() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/balance/yield', this.options());
  }

  getInterest() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/balance/interest', this.options());
  }

  getInOrderReal() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/inOrder/real', this.options());
  }

  getInOrderDolar() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/inOrder/dolar', this.options());
  }

  getInOrderBs() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/inOrder/bs', this.options());
  }

  getLatestTransactions() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/order/latesttransactions', this.options());
  }

  getAllTransactions(skip: number) {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/client/order/alltransactions/' + skip, this.options());
  }

  forgotPassword(data: any) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/forgotPassword', data, this.options());
  }

  changePassword(data: any) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/changePassword', data, this.options());
  }


  options() {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${Security.getToken()}`)
    .set('api-version', Security.versionApi());
  return { headers };
  }
}
